<template>
  <div class="form-group" :class="{'is-invalid-group':error || errorMessage}">
    
    <div>
      <!-- <div class="input-group-prepend" v-if="icon">
        <span class="input-group-text">
          <feather :type="icon" class="icon-dual"></feather>
        </span>
      </div> -->

      <div class="textOnInput">
        <label class="form-control-label" for="inputText">
          {{ label }}
        </label>
        <b-form-select
          v-bind="$attrs"
          :options="options"
          :class="[inputClass, { 'is-invalid': error || errorMessage, 'is-valid': !error && !errorMessage && isSelected }]"
          :text-field="textField"
          :value-field="valueField"
          class="form-control form-box"
          @input="onInput"
          @change="$emit('change', $event)"
        />
      </div>
    </div>

    <div class="text-muted" v-if="help">
      {{ help }}
    </div>
    <div class="invalid-feedback" v-if="errorMessage">
      {{ errorMessage }}
    </div>
    <div class="invalid-feedback" v-else-if="error">
      Please provide a valid {{ name || label || 'input' }}
    </div>
    <div class="text-success" v-else-if="(!error && !errorMessage && isSelected)">
      Looks good!
    </div>
  </div>
</template>

<script>
import Dropdown from '@src/static/dropdown'

export default {
  props: {
    inputClass: String,
    icon: String,
    label: String,
    name: String,
    help: String,
    errorMessage: String,
    trackBy: String,
    valueField: {
      type: String,
      default: '_id'
    },
    textField: {
      type: String,
      default: 'name'
    },
    moduleName: String,
    endpoint: {
      type: String,
      default: 'dropdown'
    },
    parameters: {
      type: Object,
      default: () => {}
    },
    autoload: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false,
    },
    isBlankDefault: {
      type: Boolean,
      default: false
    },
    customData: {
			type: Array,
			default: function() {
				return []
			},
		},
  },
  data () {
    return {
      options: [],
      defaultOptions: [],
      params: {},
      isSelected: false
    }
  },
  methods: {
    onInput(val) {
      this.isSelected = false
      let selected = this.getSelected(val, this.trackBy)

      // if(selected) {
      //   this.isSelected = true
      // }

      this.$emit('input', val)
      this.$emit('selected', selected)
    },
    getSelected(val, param) {
      this.isSelected = false
      let options = this.defaultOptions || []
      let ret

      if (typeof val == 'object') {
        this.$emit('input', val)
        // this.isSelected = true
        return val
      }
      else {
        for (let key in options) {
          if (key && typeof options[key] == 'object' && options[key]) {
            if (options[key][param] == val) {
              ret = options[key]
            }
          }
          else {
            if (options && options[key] == val) {
              ret = options[key]
            }
          }
        }
      }

      // if(ret) {
      //   this.isSelected = true
      // }

      return ret
    },
    fetchData () {
      let params = this.params || {}
      let moduleName = this.moduleName || ''
      if (Dropdown[moduleName] && Dropdown[moduleName].length) {
        let data = [ ...Dropdown[moduleName] ]
        
        if (this.isBlankDefault) {
          data = data.map(val => {
            if (val && val.text.toLowerCase() == 'all') {
              val.text = ''
              val.value = ''
            }
            return val
          })
        }
        this.options = data
        this.defaultOptions = data
      }
      else {
        params = {
          ...this.parameters,
          ...params
        }

        this.$store.dispatch(`${moduleName}/${this.endpoint}`, params)
        .then(result => {
          if (result && result.data) {
            let { data } = result || {}

            if (data.data) {
              data = data.data
            }

            this.options = data
            this.defaultOptions = data
          }
        })
        .catch(err => console.log(err)) 
      }
    }
  },
  mounted() {
    if (this.autoload) {
      this.fetchData()
      this.options = this.customData ? this.customData : this.options
    }
  }
}
</script>
<style>
 /* .textOnInput {
      position: relative;
  }
  .textOnInput label {
      position: absolute;
      top: -10px;
      left: 5px;
      padding: 2px;
      z-index: 1;
  }
  .textOnInput label:after {
      content: " ";
      background-color: #fff;
      width: 100%;
      height: 13px;
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: -1;
  }*/
  label {
      font-size: 11px;
      font-weight: 500;
      display: inline-block;
      margin-bottom: .5rem;
  }
  .form-box {
      box-shadow: none !important;

  }
</style>